module.exports = __webpack_public_path__ + "img/03史鹏翔.e3f61604.jpg";